module.exports = __webpack_public_path__ + "img/google-play-download-android-app.dffd25fb.svg";